import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useIsMobile } from '../../hooks/useIsMobile'
import { TextParser } from '../TextParser'
import './FollowUpStory.css'

export const FollowUpStory = () => {
  const isMobile = useIsMobile()
  const { t } = useTranslation()
  const story = t('story', { returnObjects: true })
  const part1 = [
    story.lightersEverywhere,
    story.problem,
    story.disappearance,
  ]
  const part2 = [
    story.mysteryBegins,
    story.disappearingLighters,
    story.tribalMigration,
  ]
  const part3 = [
    story.tradition,
    story.modernProblem,
    story.curse,
  ]
  const part4 = [
    story.roamingLighters,
    story.truth,
    story.lighterEmergence,
  ]
  const part5 = [
    story.blockchainSolution,
    story.lighterDescription,
    story.nftPairing,
    story.noMoreLost,
  ]
  const parts = [part1, part2, part3, part4, part5]

  return (
    <div className='page-container'>
      <div className='page-content-container'>
        {
          parts.map((part, index) => (
            <div key={index} className={`page-item ${!isMobile ? (index % 2 === 0 ? 'left' : 'right') : ''}`}>
              <div className='page-content'>
                {
                  part.map((item, itemIndex) => (
                    <p className='text-container' key={itemIndex}>
                      <TextParser text={item} />
                    </p>
                  ))
                }
              </div>
            </div>
          ))
        }
      </div>
    </div>
  )
}